import { render, staticRenderFns } from "./SideBarAdmin.vue?vue&type=template&id=b97f6c2a&"
import script from "./SideBarAdmin.vue?vue&type=script&lang=js&"
export * from "./SideBarAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports